<template lang="pug">
.idle-time-stats-item
  .stats-item-value
    | {{ percentage }}%
    span.stats-item-hours ({{ hoursDuration }})
  .stats-item-label
    span.stats-item-dot(
      v-if="dotVariant"
      :class="`stats-item-dot-${dotVariant}`"
    )
    | {{ labelText }}
</template>

<script>
export default {
  name: 'InsightsIdleTimeWidgetStatsItem',
  props: {
    percentage: {
      type: Number,
      required: true,
    },
    hoursDuration: {
      type: String,
      required: true,
    },
    labelText: {
      type: String,
      required: true,
    },
    dotVariant: {
      type: String,
      default: null,
      validator: (v) => v === null || ['remote', 'office'].includes(v),
    },
  },
};
</script>
